import useTheme from "../useTheme";
import { translations } from "./translations";

const useTranslation = () => {
  const { isLanguageEnglish } = useTheme();
  const lang = isLanguageEnglish ? "en" : "hi";
  const t = (key) => translations[lang][key] ?? translations.en[key] ?? key;
  return { t, lang };
};

export default useTranslation;
